(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["weluxe-essayage"] && !Shopify.designMode) return;
  try {
    (function () {
    if (!window.customElements || customElements.get('wl-essayage')) return;

    var NS = 'http://www.w3.org/2000/svg';
    var K = 12.6;                       // unités du dessin par millimètre
    var ARC = 'M -20 -25.4 A 340 340 0 0 0 620 -25.4';
    var FINIS = {                       // brillance de la matière
      satin:     { reflet: 0.34, eclat: 0.55, grain: 0.05, fibres: 0 },
      polyester: { reflet: 0.26, eclat: 0.32, grain: 0.13, fibres: 0 },
      coton:     { reflet: 0.10, eclat: 0.0,  grain: 0.10, fibres: 0.22 }
    };
    var memoire = {};

    function el(nom, attrs, parent) {
      var n = document.createElementNS(NS, nom);
      for (var k in attrs) if (attrs[k] !== undefined && attrs[k] !== null) n.setAttribute(k, attrs[k]);
      if (parent) parent.appendChild(n);
      return n;
    }

    function hexVersRgb(h) {
      h = h.replace('#', '');
      return [parseInt(h.slice(0, 2), 16), parseInt(h.slice(2, 4), 16), parseInt(h.slice(4, 6), 16)];
    }
    function rgbVersHex(c) {
      return '#' + c.map(function (n) { return ('0' + Math.max(0, Math.min(255, Math.round(n))).toString(16)).slice(-2); }).join('');
    }
    function nuance(hex, f) {            // f < 0 : assombrit ; f > 0 : éclaircit
      var c = hexVersRgb(hex);
      return rgbVersHex(c.map(function (v) { return f < 0 ? v * (1 + f) : v + (255 - v) * f; }));
    }

    // Couleur représentative d'une photo de cordon : médiane des pixels de luminosité moyenne, au centre de la photo.
    function lireCouleur(img) {
      var cle = img.currentSrc || img.src;
      if (memoire[cle]) return memoire[cle];
      var w = img.naturalWidth, h = img.naturalHeight;
      if (!w || !h) return null;
      try {
        var c = document.createElement('canvas');
        c.width = 32; c.height = 32;
        var x = c.getContext('2d', { willReadFrequently: true });
        var s = Math.min(w, h) * 0.6;
        x.drawImage(img, (w - s) / 2, (h - s) / 2, s, s, 0, 0, 32, 32);
        var d = x.getImageData(0, 0, 32, 32).data;
        var px = [];
        for (var i = 0; i < d.length; i += 4) px.push([0.2126 * d[i] + 0.7152 * d[i + 1] + 0.0722 * d[i + 2], d[i], d[i + 1], d[i + 2]]);
        px.sort(function (a, b) { return a[0] - b[0]; });
        var sel = px.slice(Math.floor(px.length * 0.4), Math.floor(px.length * 0.8));
        function mediane(k) {
          var v = sel.map(function (p) { return p[k]; }).sort(function (a, b) { return a - b; });
          return Math.round(v[Math.floor(v.length / 2)]);
        }
        var hex = rgbVersHex([mediane(1), mediane(2), mediane(3)]);
        memoire[cle] = hex;
        return hex;
      } catch (e) {
        return null;
      }
    }

    function quandChargee(img, fn) {
      if (img.complete && img.naturalWidth) { fn(); return; }
      img.loading = 'eager';
      img.addEventListener('load', fn, { once: true });
    }

    class WlEssayage extends HTMLElement {
      connectedCallback() {
        if (this._pret) return;
        if (document.readyState === 'loading') {
          var soi = this;
          document.addEventListener('DOMContentLoaded', function () { soi.connectedCallback(); }, { once: true });
          return;
        }
        this._pret = true;
        this.uid = this.dataset.uid || ('wl-essai-' + Math.random().toString(36).slice(2, 8));
        this.d = parseFloat(this.dataset.diametre) || 1.5;
        this.fini = FINIS[this.dataset.fini] ? this.dataset.fini : 'satin';
        this.motif = this.dataset.motif || 'medaille';
        this.nom = this.querySelector('[data-wl-essai-nom]');
        this.dessiner();
        this.brancherMetaux();
        this.brancherLot();
      }

      dessiner() {
        var scene = this.querySelector('.wl-essai__scene');
        var u = this.uid, W = this.d * K, F = FINIS[this.fini];
        var svg = el('svg', { viewBox: '0 0 600 300', role: 'img', focusable: 'false', 'aria-label': 'Cordon de ' + String(this.d).replace('.', ',') + ' mm monté sur un bijou, dans la teinte choisie' });
        var defs = el('defs', {}, svg);

        function flou(id, sd) {
          var f = el('filter', { id: u + '-' + id, filterUnits: 'userSpaceOnUse', x: -100, y: -200, width: 800, height: 700 }, defs);
          el('feGaussianBlur', { stdDeviation: sd }, f);
        }
        flou('ombre', (0.32 * W).toFixed(2));
        flou('doux', (0.16 * W).toFixed(2));
        flou('net', (0.05 * W).toFixed(2));
        flou('ombre-bijou', 7);
        flou('eclat', 2.2);
        flou('flou-bijou', 9);
        flou('fondu', 1.6);

        var masque = el('mask', { id: u + '-tube', maskUnits: 'userSpaceOnUse', x: -60, y: -120, width: 720, height: 520 }, defs);
        el('path', { d: ARC, fill: 'none', stroke: '#fff', 'stroke-width': W.toFixed(2) }, masque);

        // fibres du coton : un bruit fin, rendu en points sombres
        var fib = el('filter', { id: u + '-fibres', x: 0, y: 0, width: 1, height: 1 }, defs);
        el('feTurbulence', { type: 'fractalNoise', baseFrequency: '0.9 0.55', numOctaves: 2, seed: 7 }, fib);
        el('feColorMatrix', { type: 'matrix', values: '0 0 0 0 0  0 0 0 0 0  0 0 0 0 0  0 0 0 -2.2 1.25' }, fib);

        // dégradés du métal (couleurs données par la feuille de style, selon le métal choisi)
        var bord = el('linearGradient', { id: u + '-bord', x1: 0, y1: 0, x2: 1, y2: 1 }, defs);
        [[0, 'm5'], [0.35, 'm4'], [0.6, 'm2'], [1, 'm1']].forEach(function (s) {
          el('stop', { offset: s[0], style: 'stop-color: var(--wl-' + s[1] + ')' }, bord);
        });
        [['multi', 0], ['multi-sombre', -0.4]].forEach(function (m) {
          var lg = el('linearGradient', { id: u + '-' + m[0], gradientUnits: 'userSpaceOnUse', x1: 0, y1: 0, x2: 600, y2: 0 }, defs);
          ['#e8452f', '#f2b134', '#3fae5a', '#2f7fd1', '#8e4fc9', '#e84f9a', '#e8452f'].forEach(function (c, i, t) {
            el('stop', { offset: (i / (t.length - 1)).toFixed(3), 'stop-color': nuance(c, m[1]) }, lg);
          });
        });

        var racine = el('g', { transform: this.motif === 'barrette' ? 'translate(0 26)' : null }, svg);
        // 1. ombre portée du cordon
        el('path', { d: ARC, fill: 'none', stroke: '#3a2e1c', 'stroke-opacity': 0.28, 'stroke-width': W.toFixed(2), filter: 'url(#' + u + '-ombre)', transform: 'translate(' + (0.22 * W).toFixed(2) + ' ' + (0.46 * W).toFixed(2) + ')' }, racine);

        // 2. le cordon : bandes concentriques (volume), puis ombre propre, reflet et grain dans le tube
        var cordon = el('g', { class: 'wl-essai__cordon' }, racine);
        this.bandes = [
          [1.0, -0.42], [0.82, -0.2], [0.58, 0], [0.3, 0.1]
        ].map(function (b) {
          var p = el('path', { d: ARC, fill: 'none', 'stroke-width': (b[0] * W).toFixed(2), 'data-nuance': b[1] }, cordon);
          return p;
        });
        var tube = el('g', { mask: 'url(#' + u + '-tube)' }, cordon);
        el('path', { d: ARC, fill: 'none', stroke: '#000', 'stroke-opacity': 0.34, 'stroke-width': (0.75 * W).toFixed(2), filter: 'url(#' + u + '-doux)', transform: 'translate(' + (0.16 * W).toFixed(2) + ' ' + (0.4 * W).toFixed(2) + ')' }, tube);
        el('path', { d: ARC, fill: 'none', stroke: '#fff', 'stroke-opacity': F.reflet, 'stroke-width': (0.38 * W).toFixed(2), filter: 'url(#' + u + '-doux)', transform: 'translate(' + (-0.08 * W).toFixed(2) + ' ' + (-0.24 * W).toFixed(2) + ')' }, tube);
        if (F.eclat) el('path', { d: ARC, fill: 'none', stroke: '#fff', 'stroke-opacity': F.eclat, 'stroke-width': (0.09 * W).toFixed(2), filter: 'url(#' + u + '-net)', transform: 'translate(' + (-0.06 * W).toFixed(2) + ' ' + (-0.27 * W).toFixed(2) + ')' }, tube);
        // grain du tressage : fines stries
        el('path', { d: ARC, fill: 'none', stroke: '#000', 'stroke-opacity': F.grain, 'stroke-width': W.toFixed(2), 'stroke-dasharray': (0.16 * W).toFixed(2) + ' ' + (0.2 * W).toFixed(2) }, tube);
        el('path', { d: ARC, fill: 'none', stroke: '#fff', 'stroke-opacity': F.grain * 0.8, 'stroke-width': (0.6 * W).toFixed(2), 'stroke-dasharray': (0.12 * W).toFixed(2) + ' ' + (0.24 * W).toFixed(2), 'stroke-dashoffset': (0.18 * W).toFixed(2), transform: 'translate(0 ' + (-0.15 * W).toFixed(2) + ')' }, tube);
        if (F.fibres) el('rect', { x: -60, y: -120, width: 720, height: 520, filter: 'url(#' + u + '-fibres)', opacity: F.fibres }, tube);

        // 3. le bijou
        this.dessinerBijou(svg, racine, u);

        scene.textContent = '';
        scene.appendChild(svg);
      }

      dessinerBijou(svg, racine, u) {
        var defs = svg.querySelector('defs');
        var g = el('g', { class: 'wl-essai__bijou' }, racine);
        if (this.motif === 'barrette') {
          var T = 3.4 * K, R = 340, demi = 112;
          var arcR = function (r) {
            var dx = demi * r / R, y = -140 + Math.sqrt(r * r - dx * dx);
            return 'M ' + (300 - dx).toFixed(2) + ' ' + y.toFixed(2) + ' A ' + r.toFixed(2) + ' ' + r.toFixed(2) + ' 0 0 0 ' + (300 + dx).toFixed(2) + ' ' + y.toFixed(2);
          };
          el('path', { d: arcR(R), fill: 'none', stroke: '#3a2e1c', 'stroke-opacity': 0.34, 'stroke-width': T, 'stroke-linecap': 'round', filter: 'url(#' + u + '-ombre-bijou)', transform: 'translate(6 12)' }, g);
          // arête du tube, puis volume fondu à l'intérieur du tube
          el('path', { d: arcR(R), fill: 'none', 'stroke-width': (T + 1.6).toFixed(2), 'stroke-linecap': 'round', style: 'stroke: var(--wl-m5)' }, g);
          var mt = el('mask', { id: u + '-tube-bijou', maskUnits: 'userSpaceOnUse', x: -100, y: -200, width: 800, height: 700 }, defs);
          el('path', { d: arcR(R), fill: 'none', stroke: '#fff', 'stroke-width': T, 'stroke-linecap': 'round' }, mt);
          var vol = el('g', { mask: 'url(#' + u + '-tube-bijou)' }, g);
          var fondu = el('g', { filter: 'url(#' + u + '-fondu)' }, vol);
          [[R, 1.1, 'm4'], [R + 0.05 * T, 0.8, 'm3'], [R - 0.08 * T, 0.56, 'm2'], [R - 0.2 * T, 0.26, 'm1'], [R + 0.3 * T, 0.22, 'm5'], [R + 0.42 * T, 0.12, 'm3']].forEach(function (b) {
            el('path', { d: arcR(b[0]), fill: 'none', 'stroke-width': (b[1] * T).toFixed(2), 'stroke-linecap': 'round', style: 'stroke: var(--wl-' + b[2] + ')' }, fondu);
          });
          el('path', { d: arcR(R - 0.24 * T), fill: 'none', stroke: '#fff', 'stroke-opacity': 0.85, 'stroke-width': (0.05 * T).toFixed(2), 'stroke-linecap': 'round', 'stroke-dasharray': '70 400', 'stroke-dashoffset': -30, filter: 'url(#' + u + '-net)' }, vol);
          return;
        }

        // médaille ou cœur : plaque polie, bord biseauté, reflets
        var forme, cx = 300, cy = 200, r;
        if (this.motif === 'coeur') {
          forme = 'M 300 284 C 280 264 222 226 222 178 C 222 146 245 128 270 128 C 286 128 296 137 300 149 C 304 137 314 128 330 128 C 355 128 378 146 378 178 C 378 226 320 264 300 284 Z';
          cy = 196; r = 80;
        } else {
          r = 75;
          forme = 'M ' + (cx - r) + ' ' + cy + ' A ' + r + ' ' + r + ' 0 1 0 ' + (cx + r) + ' ' + cy + ' A ' + r + ' ' + r + ' 0 1 0 ' + (cx - r) + ' ' + cy + ' Z';
        }
        var fond = el('radialGradient', { id: u + '-fond', cx: 0.34, cy: 0.28, r: 0.95 }, defs);
        [[0, 'm1'], [0.22, 'm2'], [0.55, 'm3'], [0.82, 'm4'], [1, 'm5']].forEach(function (s) {
          el('stop', { offset: s[0], style: 'stop-color: var(--wl-' + s[1] + ')' }, fond);
        });
        var clip = el('clipPath', { id: u + '-plaque' }, defs);
        el('path', { d: forme, transform: 'translate(' + cx + ' ' + cy + ') scale(0.9) translate(' + -cx + ' ' + -cy + ')' }, clip);

        el('path', { d: forme, fill: '#3a2e1c', 'fill-opacity': 0.32, filter: 'url(#' + u + '-ombre-bijou)', transform: 'translate(7 13)' }, g);
        el('path', { d: forme, style: 'fill: url(#' + u + '-bord)' }, g);
        var plaque = el('g', { 'clip-path': 'url(#' + u + '-plaque)' }, g);
        el('rect', { x: cx - 100, y: cy - 100, width: 200, height: 200, style: 'fill: url(#' + u + '-fond)' }, plaque);
        // reflet large et doux, puis zone sombre en bas à droite
        el('ellipse', { cx: cx - 0.3 * r, cy: cy - 0.38 * r, rx: 0.75 * r, ry: 0.32 * r, fill: '#fff', opacity: 0.32, filter: 'url(#' + u + '-flou-bijou)', transform: 'rotate(-32 ' + (cx - 0.3 * r) + ' ' + (cy - 0.38 * r) + ')' }, plaque);
        el('ellipse', { cx: cx + 0.45 * r, cy: cy + 0.5 * r, rx: 0.7 * r, ry: 0.28 * r, fill: '#000', opacity: 0.14, filter: 'url(#' + u + '-flou-bijou)', transform: 'rotate(-32 ' + (cx + 0.45 * r) + ' ' + (cy + 0.5 * r) + ')' }, plaque);
        // arête intérieure du biseau
        el('path', { d: forme, fill: 'none', stroke: '#fff', 'stroke-opacity': 0.5, 'stroke-width': 1.4, transform: 'translate(' + cx + ' ' + cy + ') scale(0.9) translate(' + -cx + ' ' + -cy + ')' }, g);
        el('path', { d: forme, fill: 'none', stroke: '#000', 'stroke-opacity': 0.3, 'stroke-width': 1.1 }, g);
        el('ellipse', { cx: cx - 0.45 * r, cy: cy - 0.5 * r, rx: 0.2 * r, ry: 0.07 * r, fill: '#fff', opacity: 0.9, filter: 'url(#' + u + '-eclat)', transform: 'rotate(-40 ' + (cx - 0.45 * r) + ' ' + (cy - 0.5 * r) + ')' }, g);
        el('ellipse', { cx: cx + 0.62 * r, cy: cy + 0.5 * r, rx: 0.12 * r, ry: 0.035 * r, fill: '#fff', opacity: 0.55, filter: 'url(#' + u + '-eclat)', transform: 'rotate(-40 ' + (cx + 0.62 * r) + ' ' + (cy + 0.5 * r) + ')' }, g);
      }

      teindre(hex, multi) {
        var u = this.uid;
        this.bandes.forEach(function (p, i) {
          var f = parseFloat(p.getAttribute('data-nuance'));
          if (multi) p.style.stroke = 'url(#' + u + (i === 0 ? '-multi-sombre' : '-multi') + ')';
          else p.style.stroke = f ? nuance(hex, f) : hex;
        });
      }

      brancherMetaux() {
        var self = this;
        var boutons = Array.prototype.slice.call(this.querySelectorAll('[data-metal]'));
        function choisir(metal) {
          self.dataset.metalChoisi = metal;
          boutons.forEach(function (o) { o.setAttribute('aria-pressed', o.dataset.metal === metal ? 'true' : 'false'); });
        }
        // le métal choisi suit le visiteur d'un lot à l'autre pendant sa visite
        var garde = null;
        try { garde = window.sessionStorage.getItem('wl-essai-metal'); } catch (e) {}
        if (garde === 'jaune' || garde === 'blanc') choisir(garde);
        boutons.forEach(function (b) {
          b.addEventListener('click', function () {
            choisir(b.dataset.metal);
            try { window.sessionStorage.setItem('wl-essai-metal', b.dataset.metal); } catch (e) {}
          });
        });
      }

      brancherLot() {
        var portee = this.closest('.shopify-section') || document;
        this.lot = portee.querySelector('.wl-lot');
        this.fixe = null;
        if (!this.lot) { this.teindre('#7a1b2c'); return; }
        var self = this;
        var tuiles = Array.prototype.slice.call(this.lot.querySelectorAll('.wl-lot__tile'));
        if (!tuiles.length) return;
        var depart = null;
        [/^bordeaux$/i, /^rouge$/i, /^noir$/i, /marine/i].some(function (re) {
          depart = tuiles.filter(function (t) { return re.test((t.dataset.name || '').trim()); })[0] || null;
          return !!depart;
        });
        this.essayer(depart || tuiles[0], true);
        this.lot.addEventListener('pointerover', function (ev) {
          if (ev.pointerType !== 'mouse') return;
          var t = ev.target && ev.target.closest ? ev.target.closest('.wl-lot__tile') : null;
          if (t) self.essayer(t, false);
        });
        var grille = this.lot.querySelector('.wl-lot__grid');
        if (grille) grille.addEventListener('pointerleave', function (ev) {
          if (ev.pointerType === 'mouse' && self.fixe) self.appliquer(self.fixe);
        });
        this.lot.addEventListener('click', function (ev) {
          var t = ev.target && ev.target.closest ? ev.target.closest('.wl-lot__tile') : null;
          if (t) self.essayer(t, true);
        });
      }

      essayer(tuile, fixer) {
        var self = this, nom = tuile.dataset.name || '', img = tuile.querySelector('img');
        var faire = function () {
          var couleur = img ? lireCouleur(img) : null;
          if (!couleur) return;
          var v = { nom: nom, couleur: couleur, multi: /multicol/i.test(nom) };
          if (fixer) self.fixe = v;
          self.appliquer(v);
        };
        if (img) quandChargee(img, faire); else faire();
      }

      appliquer(v) {
        this.teindre(v.couleur, v.multi);
        if (this.nom) this.nom.textContent = v.nom;
      }
    }

    customElements.define('wl-essayage', WlEssayage);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["weluxe-eventail"] && !Shopify.designMode) return;
  try {
    (function () {
    if (!window.customElements || customElements.get('wl-eventail')) return;

    class WlEventail extends HTMLElement {
      connectedCallback() {
        if (this._pret) return;
        // Les enfants ne sont pas encore lus si la page est en cours de chargement.
        if (document.readyState === 'loading') {
          var soi = this;
          document.addEventListener('DOMContentLoaded', function () { soi.connectedCallback(); }, { once: true });
          return;
        }
        this._pret = true;
        // Navigateurs sans :has() : le même étirement du bloc parent, fait ici.
        var parent = this.parentElement;
        if (parent && !(window.CSS && CSS.supports && CSS.supports('selector(:has(*))'))) parent.style.alignSelf = 'stretch';
        this.lames = Array.prototype.slice.call(this.querySelectorAll('.wl-ev__lame'));
        this.nom = this.querySelector('.wl-ev__nom');
        this.eventail = this.querySelector('.wl-ev__eventail');
        if (!this.lames.length || !this.nom || !this.eventail) return;
        this.matiere = this.dataset.matiere || '';
        this.defaut = this.nom.innerHTML;
        this.actif = -1;
        this.charge = false;
        var self = this;

        this.lames.forEach(function (b, i) {
          b.addEventListener('mouseenter', function () { self.montrer(i); });
          b.addEventListener('focus', function () { self.montrer(i); });
          b.addEventListener('click', function () { self.choisir(i); });
          b.addEventListener('keydown', function (ev) { self.clavier(ev, i); });
        });
        this.eventail.addEventListener('mouseleave', function () { self.revenir(); });

        this.mesurer = this.mesurer.bind(this);
        if ('ResizeObserver' in window) {
          this.ro = new ResizeObserver(this.mesurer);
          this.ro.observe(this);
        } else {
          window.addEventListener('resize', this.mesurer);
        }
        this.mesurer();

        if ('IntersectionObserver' in window) {
          this.io = new IntersectionObserver(function (entrees) {
            for (var k = 0; k < entrees.length; k++) {
              if (entrees[k].isIntersecting) {
                self.io.disconnect();
                self.charger();
                self.ouvrir();
                return;
              }
            }
          }, { rootMargin: '0px 0px -10% 0px', threshold: 0.2 });
          if (!this.hidden) this.io.observe(this);
        } else {
          this.charger();
          this.ouvrir();
        }
      }

      disconnectedCallback() {
        if (this.ro) this.ro.disconnect();
        if (this.io) this.io.disconnect();
      }

      // Appelé quand un onglet affiche cet éventail.
      activer() {
        this.hidden = false;
        if (this.io) this.io.disconnect();
        this.mesurer();
        this.charger();
        this.classList.remove('est-ouvert');
        void this.offsetWidth;
        var self = this;
        requestAnimationFrame(function () { self.ouvrir(); });
      }

      charger() {
        if (this.charge) return;
        this.charge = true;
        this.lames.forEach(function (b) {
          if (b.dataset.src) b.style.backgroundImage = 'url("' + b.dataset.src + '")';
        });
      }

      ouvrir() {
        this.classList.add('est-ouvert');
      }

      mesurer() {
        var W = this.clientWidth, H = this.clientHeight;
        if (!W || !H) return;
        var A = W < 520 ? 56 : 70;
        var portrait = this.classList.contains('wl-ev--portrait');
        var hautNom = 62, leve = 22, marge = 18;
        var L = Math.min(H - hautNom - leve - marge - 30 - 10, (W / 2 - 18) / Math.sin(A * Math.PI / 180), 340);
        L = Math.max(110, Math.round(L));
        var bas = 30, haut = 18;
        if (portrait) {
          var total = hautNom + 10 + leve + L;
          var depart = Math.max(18, (H - total) / 2);
          haut = Math.round(depart);
          bas = Math.max(24, Math.round(H - depart - total));
        }
        this.style.setProperty('--wl-ev-l', L + 'px');
        this.style.setProperty('--wl-ev-bas', bas + 'px');
        this.style.setProperty('--wl-ev-haut', haut + 'px');
        var n = this.lames.length;
        this.lames.forEach(function (b, i) {
          var a = n > 1 ? -A + i * (2 * A / (n - 1)) : 0;
          b.style.setProperty('--a', a.toFixed(2) + 'deg');
        });
      }

      texte(i) {
        var b = this.lames[i];
        this.nom.textContent = '';
        var t = document.createElement('b');
        t.textContent = b.dataset.nom || '';
        var s = document.createElement('span');
        // Éventail mélangé : chaque lame donne sa propre matière.
        s.textContent = b.dataset.matiere
          ? b.dataset.matiere
          : (this.matiere ? this.matiere + ' · ' : '') + 'teinte ' + (i + 1) + ' sur ' + this.lames.length;
        this.nom.appendChild(t);
        this.nom.appendChild(s);
      }

      montrer(i) {
        this.texte(i);
      }

      revenir() {
        if (this.actif >= 0) this.texte(this.actif);
        else this.nom.innerHTML = this.defaut;
      }

      choisir(i) {
        if (this.actif >= 0 && this.lames[this.actif]) this.lames[this.actif].classList.remove('est-actif');
        this.actif = i;
        this.lames[i].classList.add('est-actif');
        this.texte(i);
      }

      clavier(ev, i) {
        var j = -1;
        if (ev.key === 'ArrowRight' || ev.key === 'ArrowDown') j = Math.min(this.lames.length - 1, i + 1);
        else if (ev.key === 'ArrowLeft' || ev.key === 'ArrowUp') j = Math.max(0, i - 1);
        else if (ev.key === 'Home') j = 0;
        else if (ev.key === 'End') j = this.lames.length - 1;
        if (j < 0 || j === i) return;
        ev.preventDefault();
        this.lames[i].setAttribute('tabindex', '-1');
        this.lames[j].setAttribute('tabindex', '0');
        this.lames[j].focus();
      }
    }

    customElements.define('wl-eventail', WlEventail);
  })();
  } catch(e) { console.error(e); }
})();

})();
